import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface DocumentosProtocoloViaPayload {
  codigo: string;
  version: number;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface DocumentosProtocoloVia {
  id?: number;
  codigo: string;
  version: number;
  fecha_designacion: string;
  fecha_vencimiento: string;
  motivo_creacion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface DocumentosProtocoloViaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class DocumentosProtocoloViaService {
  private readonly apiUrl = `${environment.apiUrl}/api/documentos_protocolo_via`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<DocumentosProtocoloVia[]> {
    return this.http.get<DocumentosProtocoloVia[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<DocumentosProtocoloVia> {
    return this.http.get<DocumentosProtocoloVia>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  // Crear
  create(
    payload: DocumentosProtocoloViaPayload,
  ): Observable<DocumentosProtocoloViaResponse> {
    return this.http.post<DocumentosProtocoloViaResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<DocumentosProtocoloViaPayload>,
  ): Observable<DocumentosProtocoloViaResponse> {
    return this.http.put<DocumentosProtocoloViaResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  // Inactivar
  inactivar(id: number): Observable<DocumentosProtocoloViaResponse> {
    return this.http.put<DocumentosProtocoloViaResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      },
    );
  }

  // Activar
  activar(id: number): Observable<DocumentosProtocoloViaResponse> {
    return this.http.put<DocumentosProtocoloViaResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      },
    );
  }
}